import dayjs from 'dayjs'
import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'

const schema = () =>
  z.object({
    score: z
      .string({ required_error: 'Score is required' })
      .min(1, 'Score is required'),
    date: z
      .custom<dayjs.Dayjs>()
      .refine((val) => dayjs.isDayjs(val), {
        message: 'Invalid date format',
      })
      .refine((val) => dayjs.isDayjs(val) && val.isValid(), {
        message: 'Invalid date',
      })
      .nullish(),
  })

export type AddNewScoreModel = z.infer<ReturnType<typeof schema>>

export const useAddNewScoreForm = () => {
  const addNewScoreFormTypeSchema = schema()
  const { form, rule } = useFormWithZod(addNewScoreFormTypeSchema)
  return { form, rule, schema: addNewScoreFormTypeSchema }
}
